module.exports = __webpack_public_path__ + "assets/img/Rules_tit.85e6e0af.png";